import { createTheme } from '@mui/material/styles';
import {green } from '@mui/material/colors';


const theme = createTheme({
    palette: {
      primary: {
        // Purple and green play nicely together.
        main:"#24378F",
      },
      secondary: {
        // This is green.A700 as hex.
        main: green[100],
      },
    },
    typography: {
      fontFeatureSettings: `'pnum' on, 'lnum' on`,
      fontFamily: [
        "Raleway", "sans-serif"
      ].join(','),
    }
  });
  
  export default theme;